import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const WrapperStyled = styled.div`
  box-sizing: border-box;
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 4rem;
  padding: 3rem 2rem 4rem;
  text-align: center;
  color: ${colors.neutral[900]};
`;

export const TitleStyled = styled.h4`
  margin: 1.5rem;
  ${typography.bold[20]}
`;

export const MessageStyled = styled.p`
  ${typography.regular[16]}
  margin: 0 0 3rem;
  max-width: 75rem;
`;

export const ActionsWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DisabledMessageStyled = styled.span`
  margin: 1rem 0 0;
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: left;
  color: ${colors.red[600]};
`;
